import React from 'react'
import { Platform, StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native';
import PhoneInput from "react-native-phone-number-input";
import Ionicons from "@react-native-vector-icons/ionicons/static";

// * Language 
import { useTranslation } from 'react-i18next';

const CustomPhoneNumber = React.forwardRef(({ defaultValue, value, defaultCode, onChangeText, onChangeFormattedText, disabled = false, type = "PRIMARY" }, ref) => {

    const { t } = useTranslation();
    const { colors } = useTheme();
    const styles = makeStyles(colors);

    return (
        // disable whole component based on disabled flag
        <View style={[
            styles.container,
            styles[`container_${type}`]
        ]}
            pointerEvents={disabled ? 'none' : 'auto'}>
            <PhoneInput
                ref={ref}
                placeholder={`${t('common:phoneNumber')}...`}
                defaultValue={defaultValue}
                defaultCode={defaultCode}
                layout="first"
                onChangeText={onChangeText}
                onChangeFormattedText={onChangeFormattedText}
                textInputProps={{
                    placeholderTextColor: '#a1a1a1',
                    // TODO: check correct on ios & android
                    selectionColor: '#0d4a3a',
                    // editable: !disabled
                }}
                textInputStyle={[styles.input, styles[`input_${type}`]]}
                codeTextStyle={styles.codeText}
                countryPickerProps={styles.countryPickerProps}
                flagButtonStyle={styles.button}
                textContainerStyle={styles.innerContainer}
                containerStyle={[styles.innerContainer,]}
                renderDropdownImage={<Ionicons
                    name="chevron-down"
                    style={styles.icon}
                />}
            />
        </View>
    )
});

const makeStyles = (colors) => StyleSheet.create({

    input_MYPROFILE: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 0,
    },

    container_MYPROFILE: {
        flex: 1,
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        padding: 5,
    },

    container: {
        backgroundColor: colors.white_or_transparent,
        borderColor: colors.border_card,
        borderWidth: 2,
        borderRadius: 5,
        marginVertical: 5,
    },

    innerContainer: {
        flex: 4,
        width: '100%',
        height: '100%',
        paddingBottom: 0,
        paddingTop: 0,
        backgroundColor: colors.white_or_transparent,
    },

    codeText: {
        backgroundColor: colors.background_dropdown,
        color: colors.text_primary,
        borderRadius: 10,
        flex: 1,
    },

    input: {
        backgroundColor: colors.background_dropdown,
        color: colors.text_primary,
        borderRadius: 10,
        flex: 4,
        fontSize: 16,
    },

    button: {
        color: colors.buttons,
        flex: 1,
    },

    icon: {
        fontSize: 17,
        color: '#a1a1a1',
    },

    countryPickerProps: {
        withEmoji: Platform.OS === 'web' ? false : true,
        renderFlagButton: null,
    }
});

export default CustomPhoneNumber;